export const wppAudioFormat = "oga";

export const acceptedAudioType = ["ogg", "mp3", "wav", "opus", wppAudioFormat];

export const acceptedImgType = ["jpeg", "jpg", "png", "svg", "gif", "webp"];

export const acceptedVideoType = ["webm", "mp4"];

export const csvURI = "data:text/csv;charset=utf-8,%EF%BB%BF";

export const audiosAcceptedInInput =
  "audio/acc,audio/mp4,audio/mpeg,audio/amr,audio/ogg";

export const documentAcceptedInInput =
  "text/plain,application/pdf,application/msword,.log";

export const imagesAcceptedInInput = "image/jpeg,image/png,image/webp";

export const videosAcceptedInInput = "video/mp4,video/3gp";

export const filesAcceptedInInput = `${imagesAcceptedInInput},${audiosAcceptedInInput},${videosAcceptedInInput},${documentAcceptedInInput}`;

export const textURI = "data:text/plain;charset=utf-8,%EF%BB%BF";

export const audioType = "audio/webm";
